import React, { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { ASSETS } from "../data/site";
import { Footer } from "../components/landing/Footer";
import { InviteCard } from "../components/invite/InviteCard";
import { DownloadButtons } from "../components/invite/DownloadButtons";
import { useInvite } from "../components/invite/useInvite";

const usePrivatePageMeta = () => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = "You're invited to a SisterSafe Circle";
    const metas = [
      ["robots", "noindex, nofollow"],
      ["referrer", "no-referrer"],
    ].map(([name, content]) => {
      const m = document.createElement("meta");
      m.name = name;
      m.content = content;
      document.head.appendChild(m);
      return m;
    });
    return () => {
      document.title = prevTitle;
      metas.forEach((m) => m.remove());
    };
  }, []);
};

export default function Invite() {
  const { token } = useParams();
  const { loading, status, data, retry } = useInvite(token);
  usePrivatePageMeta();

  return (
    <div className="flex min-h-screen flex-col bg-[#FBFBF9]" data-testid="invite-page">
      <header className="mx-auto flex w-full max-w-7xl px-6 py-5 md:px-12">
        <Link to="/" className="flex items-center gap-2.5" data-testid="invite-logo">
          <img src={ASSETS.logoIcon} alt="SisterSafe" className="h-9 w-9 object-contain" />
          <span className="font-heading text-xl font-semibold tracking-tight text-[#111E16]">SisterSafe</span>
        </Link>
      </header>
      <main className="flex flex-1 items-start justify-center px-5 pb-20 pt-6 md:pt-14">
        <div className="w-full max-w-lg rounded-[2rem] border border-[#E8EBE9] bg-white p-7 shadow-[0_20px_60px_-30px_rgba(47,94,67,0.35)] sm:p-10">
          {loading ? (
            <div className="flex flex-col items-center py-16 text-[#4A5F52]" data-testid="invite-loading">
              <Loader2 className="h-7 w-7 animate-spin text-[#2F5E43]" />
              <p className="mt-4 text-sm">Loading your invitation</p>
            </div>
          ) : (
            <InviteCard token={token} status={status} data={data} onRetry={retry} />
          )}
          <DownloadButtons />
        </div>
      </main>
      <Footer />
    </div>
  );
}
